import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary";
import TableReportHelper from "report/helper";
import _ from "lodash"

export default async function baReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;
    let avgConformidadeApts = 0, isIndice
    const f = parseFloat
    const meta = f(_.get(visita, "cliente.data.params.ba." + tipoName.toLowerCase() + ".meta"))

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    const chartSegments = [0, 76, parseInt(params.meta), 100];

    async function getChart(conformidade) {
        return h.gaugeChart(
            {
                width: 200,
                height: 130,
                maxSegmentLabels: 5,
                customSegmentStops: chartSegments,
                segments: 3,
                segmentsColors: ["#6bd72d", "#ecdb23", "#fe4719"],
                series: [{ name: "", values: conformidade }],
            },
            { alignment: "center", colSpan: 4 }
        );
    }

    let aptsBA = visita?.data?.apontamentos?.pragas?.ba || []
    let qtdAptsBA = aptsBA.length

    for (let i = 0; i < qtdAptsBA; i++) {
        avgConformidadeApts = avgConformidadeApts + f(aptsBA[i].conformidade)
    }

    if ((avgConformidadeApts / qtdAptsBA).toFixed(2) > meta) {
        isIndice = 'Sim'
    } else {
        isIndice = 'Não'
    }

    return indicadorReportSummary(
        indicador,
        visita,
        tipoName,
        params,
        getChart,
        "%",
        "conformidade",
        params.meta,
        true,
        { title: "Índice", value: isIndice }
    )
}
